import React from "react";
import { CirclesWithBar } from "react-loader-spinner";
import {
  LoadingContainer,
  LoadingBox,
  LoadingBigContainer,
} from "./loadingComponents";

function Loading() {
  return (
    <LoadingBigContainer>
      <LoadingContainer>
        <LoadingBox>
          <CirclesWithBar
            visible={true}
            height="150"
            width="150"
            color="#ff8787"
            outerCircleColor="#ff8787"
            innerCircleColor="#ff8787"
            barColor="#4fa94d"
            ariaLabel="circles-with-bar-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />
        </LoadingBox>
      </LoadingContainer>
    </LoadingBigContainer>
  );
}

export default Loading;
